var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mt-5"},[_c('h2',{staticClass:"text-align--center mb-4"},[_vm._v("Personointilomake")]),_c('div',{staticClass:"text-align--center intro mb-2"},[_vm._v("\n    Valitse malli:\n  ")]),_c('car-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }